import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { DeleteLocationDto, UpdateLocationFormData } from "./Dto";
import { CreateLocationDto } from "./Dto/CreateLocationDto";
import { LocationListEntity } from "./Entity";
import { LocationEntity } from "./Entity/LocationEntity";

export const createLocation = async (
  payload: CreateLocationDto
): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.location.createLocation,
      JSON.stringify(CreateLocationDto.removeEmptyStringProperties(payload))
    );
    return true;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to create location");
  }
};

export const getLocationList = async (): Promise<LocationListEntity[]> => {
  try {
    const response = await HttpService.get(ApiService.location.getLocation);
    return LocationListEntity.fromJSON(response.data.data);
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to fetch location list");
  }
};

export const deleteLocation = async (
  payload: DeleteLocationDto
): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.location.deleteLocation,
      JSON.stringify(payload)
    );
    return true;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to delete location");
  }
};

export const getLocationDetail = async (
  id: string
): Promise<LocationEntity> => {
  try {
    const response = await HttpService.get(
      `${ApiService.location.getLocationDetail}/${id}`
    );
    return LocationEntity.fromJson(response.data.data);
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to get location detail");
  }
};

export const updateLocation = async (
  payload: UpdateLocationFormData
): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.location.updateLocation,
      JSON.stringify(payload)
    );
    return true;
  } catch (error) {
    console.error("Error fetching profile:", error);
    throw new Error("Failed to update location");
  }
};
